<template>
  <div class="retail">
    <Tabs
      title="Заказы от дилеров"
      :tabs="tabs"
      :active="tabActive"
      @tabActiveUpdate="updateOrdersTab"
      class="tab--table"
    >
      <template #tabsAfter>
        <OrderRate @changeCurrency="changeCurrency" :currency="currency" />
      </template>
      <template #multiselectAfter
        ><OrderRate @changeCurrency="changeCurrency" :currency="currency" />
      </template>
      <Journal
        v-if="tabActive === tabs[0].path"
        :inputId="'dealers'"
        :dealer="true"
        :isSelectedList="true"
        :tabActive="tabActive"
        :list="dealersOrder ? dealersOrder.data : []"
        :pagination="dealersOrder ? dealersOrder.pagination : null"
        :currency="currency"
        @updateJournal="updateOrders"
      >
      </Journal>
      <Journal
        v-if="tabActive === tabs[1].path"
        :inputId="'dealers-archived'"
        :dealer="true"
        :archived="true"
        :isSelectedList="true"
        :tabActive="tabActive"
        :list="dealersOrderArchived ? dealersOrderArchived.data : []"
        :pagination="dealersOrderArchived ? dealersOrderArchived.pagination : null"
        :currency="currency"
        @updateJournal="updateOrders"
      >
      </Journal>
    </Tabs>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { ORDER_TYPE } from '@/store/modules/account/variables';
import Orders from '@/mixins/Account/orders.mixin';
import currencyMixin from '@/mixins/currency.mixin';

export default {
  name: 'AccountOrdersDealer',

  components: {
    Tabs: () => import('@/pages/account/components/Tabs'),
    Journal: () => import('./components/journal/Journal'),
    OrderRate: () => import('@/components/OrderRate'),
  },

  mixins: [Orders, currencyMixin],

  metaInfo() {
    return {
      title: `Заказы от дилеров - Личный кабинет дилера - ${this.getDealerName}`,
    };
  },

  data: () => ({
    type: ORDER_TYPE.dealers,
  }),

  computed: {
    ...mapState({
      dealersOrder: state => state.account.orders.dealersOrder,
      dealersOrderArchived: state => state.account.orders.dealersOrderArchived,
    }),

    ...mapGetters('user', ['getDealerName']),
  },

  created() {
    this.setDealers(true);
  },

  methods: {
    ...mapActions('account/dealers', ['setDealers']),
  },
};
</script>
